module.exports = __webpack_public_path__ + "static/media/q1.2614aa9f.png";